import { environment } from '../../../environments/environment';

export const SERVICE_ENDPOINT = Object.freeze({
  getSelfInfo: `${environment.apiUrl}/get-self-info`,
  login: `${environment.apiUrl}/login`,
  checkToken: `${environment.apiUrl}/check-token`,
  checkIp: `${environment.apiUrl}/check-ip`,
  getContact: `${environment.apiUrl}/get-contact`,
  getContentPayment: `${environment.apiUrl}/api/portal/content-payment`,
  getPriceTerm: `${environment.apiUrl}/get-price-term`,
  bestPriceInMonth: `${environment.apiUrl}/best-price-in-month`,
  searchFlight: `${environment.apiUrl}/api/portal/search-flight`,
  searchMinFare: `${environment.apiUrl}/api/portal/search-minfare`,
  searchPriceSuggest: `${environment.apiUrl}/api/portal/search-price-suggest`,
  checkBooking: `${environment.apiUrl}/api/portal/check-booking`,
  getServicesByVendor: `${environment.apiUrl}/api/portal/services-by-vendor`,
  getAncillary: `${environment.apiUrl}/api/portal/ancillary`,
  getSeatMap: `${environment.apiUrl}/api/portal/seat-map`,
  booking: `${environment.apiUrl}/api/portal/booking`,
  getPaymentFee: `${environment.apiUrl}/api/portal/get-payment-fee`,
  updatePaymentMethod: `${environment.apiUrl}/update-payment-method`,
  payStore: `${environment.apiUrl}/pay-store`,
  payOnline: `${environment.apiUrl}/api/portal/pay-online`,
  paymentProvider: `${environment.apiUrl}/api/portal/payment-provider`,
  bookingReservation: `${environment.apiUrl}/api/portal/booking-reservation`,
  bookingIssue: `${environment.apiUrl}/api/portal/booking-issue`,
  reviewBooking: `${environment.apiUrl}/api/portal/review-booking`,
});
